var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3351 17.3351L21 21M3.31573 13.7811C2.89476 11.9864 2.89476 10.1187 3.31573 8.324C3.89864 5.83897 5.83897 3.89864 8.324 3.31573C10.1187 2.89476 11.9864 2.89476 13.781 3.31573C16.2661 3.89864 18.2064 5.83897 18.7893 8.324C19.2103 10.1187 19.2103 11.9864 18.7893 13.781C18.2064 16.2661 16.2661 18.2064 13.781 18.7893C11.9864 19.2103 10.1187 19.2103 8.324 18.7893C5.83897 18.2064 3.89864 16.2661 3.31573 13.7811Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3e02fc0c1d77ad6e1a71775d6b529d5f.svg";
export { ForwardRef as ReactComponent };